import Icon from '../components/Icon.vue'

Icon.register({
  lightbulb: {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M96.1 454.4C96.1 460.6 97.9 466.8 101.4 472L118.5 497.7A32-32 0 0 1 145.2 512H206.9A32-32 0 0 1 233.5 497.7L250.6 472A32-32 0 0 1 255.9 454.4L256 416H96L96.1 454.4zM0 176C0 220.4 16.4 260.9 43.6 291.8 60.1 310.6 85.9 350 95.8 383.2 95.8 383.5 95.8 383.7 95.9 384H256.1C256.2 383.7 256.2 383.5 256.2 383.2 266.1 350 291.9 310.6 308.4 291.8 335.6 260.9 352 220.4 352 176 352 78.6 272.9-0.3 175.4 0 73.4 0.3 0 83 0 176zM176 96C131.9 96 96 131.9 96 176 96 184.8 88.8 192 80 192S64 184.8 64 176C64 114.2 114.2 64 176 64 184.8 64 192 71.2 192 80S184.8 96 176 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lightbulb.js
// module id = ja6c
// module chunks = 144